import { render, staticRenderFns } from "./MovementTypeForm.vue?vue&type=template&id=d764efde"
import script from "./MovementTypeForm.vue?vue&type=script&lang=js"
export * from "./MovementTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports